import type { SiteMapItems } from '../models/siteMap';
import { LocalizationItem } from './LocalizationItem';

export const SiteMap: SiteMapItems = {
  Category: {
    Path: '/:categoryName',
    Title: LocalizationItem.Category,
    To: (categoryName: string) => `/${categoryName}`,
  },
  Home: {
    Path: '/',
    Title: LocalizationItem.SupportCenter,
  },
  Search: {
    Path: '/search',
    Title: LocalizationItem.Search,
    To: (query: string) => `/search?query=${query}`,
  },
};
